import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify.js';
//@ts-ignore
import VueMask from 'v-mask';
// @ts-ignore
import VueExcelViewer from '@uublue/vue-excel-viewer';
import '@uublue/vue-excel-viewer/lib/vue-excel-viewer.css';
Vue.use(VueExcelViewer);
//@ts-ignore
import { VueMaskFilter } from 'v-mask';

import { plugin } from '@ifr/form-questionnaire';
Vue.use(plugin);

import { AxiosError, AxiosStatic } from 'axios';
declare module 'vue/types/vue' {
  interface Vue {
    $axios: AxiosStatic;
  }
}
import { axios } from '@/plugins/http-axios';

import VueMoment from 'vue-moment';
import moment from 'moment';
import polyfills from '@/plugins/polyfills.js';
// import mock from "@/mock";
// Vue.use(FormQuestionnaire);

Vue.use(VueMask);
Vue.filter('VMask', VueMaskFilter);
moment.locale('ru');
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;
Vue.prototype.$vuetify = vuetify;

Vue.config.productionTip = false;

Vue.config.errorHandler = function (e, vm, info) {
  const isAxiosError = e instanceof AxiosError;
  if (isAxiosError) return;

  e.name = info + ' ' + e.name;
  if (vm?.$store) {
    vm.$store.dispatch('setError', e);
  }
};

Vue.config.warnHandler = function (msg, vm, trace) {
  if (vm?.$store) {
    vm.$store.dispatch('setError', new Error(msg));
  }
  console.error(msg + trace);
};

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  beforeCreate() {
    polyfills();
    // if (process.env.VUE_APP_MOCK === 'true') mock();
  },
}).$mount('#app');
